
import 'react-widgets/dist/css/react-widgets.css';
import './ReduxInput.css';
import React from 'react';
import { FormText, Input, FormGroup, Row, Col, Button, InputGroup } from 'reactstrap';
import { TextMask, InputAdapter } from 'react-text-mask-hoc';
import { NumberPicker, DropdownList } from 'react-widgets';
import ReCAPTCHA from "react-google-recaptcha";
import _ from 'lodash';

export const ReduxInput = (props) => {
  let { disabled, input, name, type, placeholder, iconClass, meta, onPaste, className, id } = props;
  let { touched, error } = meta;

  if (Array.isArray(error)) {
    error = error.map(err => <span key={err}>{err}</span>);
  }

  return (
    <div style={{ width: "100%" }}>
      <div className={iconClass ? "input-group" : null}>
        {iconClass ? <div className="input-group-prepend">
          <span className="input-group-text">
            <i className={iconClass}></i>
          </span>
        </div> : null}
        <Input
          {...input}
          id={id}
          onPaste={onPaste}
          className={(touched && error) ? className + " is-invalid" : className}
          name={name}
          type={type}
          placeholder={placeholder}
          disabled={disabled} >
        </Input>
      </div>
      {(touched && error) ? <FormText className="help-block"><p className="text-danger">{error}</p></FormText> : null}
    </div>
  );
};


export const ReduxFileInput = (props) => {
  let { disabled, input, name, iconClass, meta, className, accept } = props;
  let { touched, error } = meta;

  return (
    <div style={{ width: "100%" }}>

      <Input
        accept={accept || [".png", ".jpg", ".jpeg", ".pdf", ".doc", ".docx", ".csv", ".txt"]}
        onChange={
          (e) => {
            e.preventDefault();
            //const { fields } = this.props;
            // convert files to an array
            const files = [...e.target.files];
            //            console.log(files);
            //fields.yourField.handleChange(files);
            input.onChange(files[0]);
          }
        }
        className={(touched && error) ? className + "form-control-file is-invalid" : "form-control-file " + className}
        name={name}
        type="file"
        disabled={disabled} >
      </Input>
      {(touched && error) ? <FormText className="help-block"><p className="text-danger">{error}</p></FormText> : null}
    </div>
  );
};

export const ReduxTextAreaInput = (props) => {
  let { disabled, input, name, type, placeholder, meta, className, rows, cols, id } = props;
  let { touched, error } = meta;


  return (
    <div style={{ width: "100%" }}>
      <textarea
        {...input}
        id={id}
        rows={rows}
        cols={cols}
        className={(touched && error) ? className + " is-invalid" : "form-control " + className}
        name={name}
        type={type}
        placeholder={placeholder}
        disabled={disabled} >
      </textarea>
      {(touched && error) ? <FormText className="help-block"><p className="text-danger">{error}</p></FormText> : null}
    </div>
  );
};

export const ReduxMaskedInput = (props) => {
  let { input, name, placeholder, meta, mask, className, disabled, id } = props;
  let { touched, error } = meta;

  return (
    <div>
      <TextMask
        {...input}
        id={id}
        className={(touched && error) ? className + " form-control is-invalid" : className + " form-control"}
        name={name}
        mask={mask}
        placeholder={placeholder}
        Component={InputAdapter}
        disabled={disabled} />
      {(touched && error) ? <FormText className="help-block"><p className="text-danger">{error}</p></FormText> : null}
    </div>
  );

};

export class ReduxButtonList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      buttons: this.props.meta.initial || [],
      textValue: ""
    };
    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }
  onChange(e) {
    e.preventDefault();
    this.setState({
      textValue: e.target.value
    })

  }

  onRemove(e) {
    e.preventDefault();
    console.log(e.target.value);
    const value = e.target.value;
    //let index = this.state.buttons.indexOf(e.target.value);
    this.setState(prevState => {
      let newState = _.remove(prevState.buttons, (n) => {
        return n === value;
      });
      return {
        buttons: prevState.buttons
      }
    }, () => {
      this.props.input.onChange(this.state.buttons);
    });


  }

  onClick(e) {
    e.preventDefault();
    let textValue = this.state.textValue;
    this.setState(prevState => {
      let found = prevState.buttons.includes(textValue);
      if (!found) {
        prevState.buttons.push(textValue);
        let newState = {
          buttons: prevState.buttons,
          textValue: ""
        }
        return newState
      } else {
        let newState = {
          textValue: ""
        }
        return newState
      }
    }, () => {
      this.props.input.onChange(this.state.buttons);
    });
  }

  render() {
    let { buttons, textValue } = this.state;

    let buttonsDom = buttons.map(button => {

      return (
        <div key={button} className="float-left pb-3">
          <Button
            value={button}
            onClick={this.onRemove}
            className="btn-sm">
            <i className="fa fa-times" aria-hidden="true"></i>
            {" " + button}
          </Button>
          &nbsp;
        </div>
      );
    })

    return <div>
      {buttonsDom}
      <div>
        <InputGroup>
          <Input
            onChange={this.onChange}
            value={textValue}
            id="appendedInputButton" size="16" type="text" />
          <div className="input-group-append">
            <Button
              onClick={this.onClick}
              color="secondary">Add</Button>
          </div>
        </InputGroup>
      </div>
    </div>
  }
}

export class ReduxSelectField extends React.Component {

  constructor(props) {
    super(props)
    let { values } = props;
    this.state = {
      value: "",
      text: ""
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    let newValue = this.props.values.find(element => {
      return (element.value || element) === value.target.value;
    });

    if (newValue) {
      this.setState(
        {
          value: newValue.value || newValue,
          text: newValue.text || newValue
        },
        () => {
          this.props.input.onChange({
            value: this.state.value,
            text: this.state.text
          })

          if(this.props.onChange){
            this.props.onChange(this.state)
          }
        }
      );
    }
  }

  render() {
    let { input, name, placeholder, meta, className, values, id, open } = this.props;
    let { touched, error } = meta;


    values = values || [];
    let options = [<option key={"choose..."} >Choose...</option>];
    values.forEach(value => {

      options.push(<option key={value.value || value} value={value.value || value}>{value.text || value}</option>);

    });


    return (<div className={(touched && error) ? className + " is-invalid" : className}>
      <select
        defaultValue={"choose..."}
        id={id}
        onChange={this.onChange}
        className="custom-select"
        name={name}>
        {options}
      </select>
      {(touched && error) ? <FormText className="help-block"><p className="text-danger">{error}</p></FormText> : null}
    </div>
    );
  }
}


export const ReduxSelectDropDownListField = (props) => {
  let { input, name, placeholder, meta, className, values, id, open } = props;
  let { touched, error } = meta;


  values = values || [];

  return (<div className={(touched && error) ? className + " is-invalid" : className}>
    <DropdownList
      filter
      id={id}
      {...input}
      open={open}
      className={(touched && error) ? className + " is-invalid" : className}
      //className={"is-invalid"}
      data={values}
      placeholder={placeholder}
      textField='text'
      valueField='value'
      name={name} />
    {(touched && error) ? <FormText className="help-block"><p className="text-danger">{error}</p></FormText> : null}
  </div>
  );
};

export const ReduxCheckBoxField = (props) => {
  let { input, name, meta, className, id } = props;
  let { touched, error } = meta;


  return (<div>
    <Input  {...input}
      id={id}
      className={(touched && error) ? className + " form-check-input is-invalid" : " form-check-input " + className}
      type="checkbox" name={name} />
    {(touched && error) ? <FormText className="help-block"><p className="text-danger">{error}</p></FormText> : null}
  </div>
  );
};

export const ReduxSpinner = (props) => {
  let { input, name, meta, min, max, bsSize, value, className, id } = props;
  let { touched, error } = meta;

  return (<div>
    <NumberPicker
      id={id}
      className={(touched && error) ? className + " is-invalid" : className}
      {...input}
      bsSize={bsSize}
      min={min}
      value={value}
      max={max}
      name={name}
    />
    {(touched && error) ? <FormText className="help-block"><p className="text-danger">{error}</p></FormText> : null}
  </div>);
};


export class RadioNumber extends React.Component {

  constructor(props) {
    super(props);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.onChangeNumber = this.onChangeNumber.bind(this);
    this.state = {
      operator: null,
      number: null
    };
  }

  onChangeInput(e) {
    this.setState(
      {
        operator: e.target.value
      }, () => this.props.input.onChange(this.state)
    );
  }

  onChangeNumber(value) {
    this.setState(
      {
        number: value
      }, () => this.props.input.onChange(this.state)
    );
  }

  render() {
    let { min, max, text, name, inputValue } = this.props;

    return (
      <Row>
        <Col>
          <Input
            onChange={this.onChangeInput}
            checked={this.props.checked}
            className="form-check-input" type="radio" name={name} value={inputValue} />
        </Col>
        <Col>
          <NumberPicker
            onChange={this.onChangeNumber}
            //onClick={this.setSelected}           
            value={this.state.number}
            min={min}
            max={max}
            style={{
              width: '100px'
            }} />
          {' '}
          <strong>{text}</strong>
        </Col>
      </Row>
    );
  }
}


export const ReduxRadioFieldEntry = (props) => {
  let { name, meta, className, min, max, value } = props;
  let { touched, error, } = meta;

  return (
    <FormGroup check className="radio">
      <Input className="form-check-input" type="radio" id="radio1" name="radios" value="option1" />
      <NumberPicker
        className={(touched && error) ? className + " is-invalid" : className}
        min={min}
        value={value}
        max={max}
        name={name}
      />
    </FormGroup>
  );


};


export const ReduxRecaptcha = (props) => {
  return (<ReCAPTCHA
    sitekey={process.env.REACT_APP_RECAPTCHA || "6LfNKTwUAAAAAIIjN2vDlZRCgL4lXxk3h5jayGg9"}
    {...props.input}
  />);
};




// WEBPACK FOOTER //
// ./src/components/ReduxInput/ReduxInput.js